import { NotificationClient } from "../../../api/api";
import { AsyncOperationBuilder } from "../../../utilities/api-helper";
import { notificationClient } from "../api-clients";
import {
  notificationContentAction,
  showNotificationDrawerAction,
} from "./actions";
import { Dispatch } from "redux";

export async function getAllNotificationsContent() {
  return AsyncOperationBuilder(
    notificationContentAction,
    (apiClient) => (apiClient as NotificationClient).getUserNotifications(),
    undefined,
    notificationClient
  );
}

export const showNotificationDrawer = () => {
  return (dispatch: Dispatch) => {
    dispatch(showNotificationDrawerAction());
  };
};

export const toggleNotificationDrawer = () => {
  return (dispatch: Dispatch) => {
    dispatch(showNotificationDrawerAction());
  };
};
